// Token store em memória (acesso) + persist (refresh).
// Refresh é trocado a cada uso (rotation no backend).

interface Tokens {
  accessToken: string
  refreshToken: string
  expiresAt: number // unix sec
}

const STORAGE_KEY = 'iptv:tokens'
let tokens: Tokens | null = null

function load(): Tokens | null {
  if (typeof localStorage === 'undefined') return null
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Tokens
    if (typeof parsed.accessToken === 'string' && typeof parsed.refreshToken === 'string') {
      return parsed
    }
  } catch {
    // ignora
  }
  return null
}

function save(t: Tokens | null): void {
  if (typeof localStorage === 'undefined') return
  if (t === null) {
    localStorage.removeItem(STORAGE_KEY)
    return
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(t))
}

export function getTokens(): Tokens | null {
  if (!tokens) tokens = load()
  return tokens
}

export function setTokens(accessToken: string, refreshToken: string, expiresIn: number): void {
  tokens = {
    accessToken,
    refreshToken,
    expiresAt: Math.floor(Date.now() / 1000) + expiresIn,
  }
  save(tokens)
}

export function clearTokens(): void {
  tokens = null
  save(null)
}

export function isTokenExpired(skewSeconds = 60): boolean {
  const t = getTokens()
  if (!t) return true
  return Math.floor(Date.now() / 1000) + skewSeconds >= t.expiresAt
}
